








import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import AccountSingle from '@/components/accounts/AccountSingle.vue';
import AccountComponent from '@/components/accounts/AccountComponent.vue';
import DashboardBreadcrumbs from '@/components/breadcrumbs/DashboardBreadcrumbs.vue';
import { AccountsModule } from '@/store/dashboard/accounts/AccountsModule';
import { resolveModule } from '@/store';

@Component({
  components: {
    'dashboard-breadcrumbs': DashboardBreadcrumbs,
    'account-single': AccountSingle,
    'account-component': AccountComponent
  }
})
export default class AccountSingleView extends Vue {
  private readonly accountsModule: AccountsModule = resolveModule(AccountsModule);

  private get accountId(): number {
    return Number(this.$route.params.accountId);
  }

  @Watch('accountId')
  private async accountIdChangeHandler(value: number): Promise<void> {
    await this.accountsModule.FetchSingle(value);
  }
}
